module.exports = __webpack_public_path__ + "img/gdq_gbt854_1988.prt.547573dd.jpg";